import { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';

export default function DetailHelp() {

  useEffect(() => {

    const scrollRevealConfig = {
      reset: false,
      distance: "100px",
      duration: 500,
      delay: 400,
    };

    const revealConfig = {
      delay: 500,
      origin: 'left',
    };

    const revealConfigBottom = {
      delay: 600,
      origin: 'bottom',
    };

    const revealConfigRight = {
      delay: 700,
      origin: 'right',
    };

    const revealConfigBottomInterval = {
      delay: 500,
      origin: 'bottom',
      interval: 200,
    };

    const revealConfigTop = {
      delay: 500,
      origin: 'top',
    };

    const revealConfigLeftInterval = {
      delay: 500,
      origin: 'left',
      interval: 200,
    };

    ScrollReveal(scrollRevealConfig);

    ScrollReveal().reveal('.detail_main-title, .detail_section-title', revealConfig);
    ScrollReveal().reveal('.detail_sec-01, .detail_image', revealConfigBottom);
    ScrollReveal().reveal('.detail_text-box', revealConfigRight);
    ScrollReveal().reveal('.detail_country div', revealConfigBottomInterval);
    ScrollReveal().reveal('.detail_sec-02 .detail_image, .sec-03 .image', revealConfigTop);
    ScrollReveal().reveal('.detail_media-info li', revealConfigLeftInterval);
  }, []);

  return null;
}

